import React from 'react';
import PropTypes from 'prop-types';
import Grid from "@mui/material/Grid";
import {FormattedMessage} from "react-intl";
import HeaderContainer from "../../../../components/List/components/HeaderContainer";

Header.propTypes = {
    
};

function Header(props) {
    return (
        <HeaderContainer>
            <Grid
                item
                container
                xs={6}
            >
                <Grid item>
                    <FormattedMessage id={'wms.missionModel.header.name'} />
                </Grid>
            </Grid>

            <Grid
                item
                container
                xs={6}
                justifyContent={'end'}
            >
                <Grid container xs={3} justifyContent={"start"} item>
                    <FormattedMessage id={'wms.missionModel.header.status'} />
                </Grid>

                <Grid container xs={3} justifyContent={"start"} item>
                    <FormattedMessage id={'wms.missionModel.header.createdAt'} />
                </Grid>

                <Grid container xs={2} justifyContent={"end"} item sx={{paddingRight: "8px"}}>
                    <FormattedMessage id={'list.header.actions'} />
                </Grid>
            </Grid>
        </HeaderContainer>
    );
}

export default Header;